export const DEFAULT_S3_BASE = 'https://compulse-c360-static.s3.amazonaws.com';

export const ACCESS_TOKEN_STORAGE_KEY_STORYBOOK = 'current-access-token';
export const REFRESH_TOKEN_STORAGE_KEY_STORYBOOK = 'current-refresh-token';